module.exports = __webpack_public_path__ + "img/resultado6.09de6967.jpg";